import { Directive, Input, HostBinding, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { SipService } from '../services/sip.service';

/**
 * Dyrektywa do klikania na numery telefonów - click-to-call
 *
 * Użycie:
 * <span [appClickToCall]="'+48123456789'" [callName]="'Jan Kowalski'">+48 123 456 789</span>
 *
 * Lub z automatycznym pobieraniem numeru z tekstu elementu:
 * <span appClickToCall>+48 123 456 789</span>
 */
@Directive({
    selector: '[appClickToCall]'
})
export class ClickToCallDirective {

    @Input('appClickToCall') phoneNumber: string = '';
    @Input() callName: string = '';

    constructor(
        private sipService: SipService,
        private el: ElementRef,
        private renderer: Renderer2
    ) {}

    @HostBinding('class.click-to-call')
    get canCall(): boolean {
        return this.sipService.isVoipAvailable();
    }

    @HostBinding('style.cursor')
    get cursor(): string | null {
        return this.canCall ? 'pointer' : null;
    }

    @HostBinding('style.text-decoration')
    get textDecoration(): string | null {
        return this.canCall ? 'underline dotted' : null;
    }

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        if (!this.canCall) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();

        // Pobierz numer - z inputa lub z tekstu elementu
        let number = this.phoneNumber;
        if (!number) {
            number = this.el.nativeElement.textContent || '';
        }

        // Wyczyść numer z niepotrzebnych znaków
        number = number.replace(/[\s\-\(\)]/g, '').trim();

        if (number) {
            console.log('ClickToCall: Dialing', number, this.callName);
            this.sipService.requestDial(number, this.callName);
        }
    }

    @HostListener('mouseenter')
    onMouseEnter(): void {
        if (this.canCall) {
            this.renderer.setStyle(this.el.nativeElement, 'color', '#1976d2');
        }
    }

    @HostListener('mouseleave')
    onMouseLeave(): void {
        this.renderer.removeStyle(this.el.nativeElement, 'color');
    }
}
